// extracted by mini-css-extract-plugin
export default {"catchup_container":"CatchupContainer_catchup_container__cF4kv","active":"CatchupContainer_active__4CV6-"};